import useEvent from "react-use-event-hook";

import { useDrawers } from "@ryde/shared";

export const useOpenEntityFormCellTemplate = () => {
  const {
    openEditFormDrawer,
    openRideEditFormDrawer,
    openBookingEditFormDrawer,
  } = useDrawers();
  const openEntityForm = useEvent(({ entity, id }) => {
    switch (entity) {
      case "ride":
        return openRideEditFormDrawer({ id });
      case "booking":
        return openBookingEditFormDrawer({ id });
      default:
        return openEditFormDrawer({ id, entity });
    }
  });
  return { openEntityForm };
};
